import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReaddataComponent } from './readdata/readdata.component';
import { LoginComponent } from './login/login.component';
import { MasterrComponent } from './masterr/masterr.component';
import { FormsModule,ReactiveFormsModule  } from '@angular/forms';
import { NgxSpinnerModule } from "ngx-spinner"; 
import {MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table' ;
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatSortModule} from  '@angular/material/sort'; 
import {CountrymasterComponent} from './countrymaster/countrymaster.component'
import {CurrencymasterComponent} from './currencymaster/currencymaster.component';
import { AdminmenuComponent } from './adminmenu/adminmenu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { OnboardingComponent } from './onboarding/onboarding.component'
import {ChamasterComponent} from './chamaster/chamaster.component'
import { PortmasterComponent } from './portmaster/portmaster.component'
import { ContractsComponent } from './contracts/contracts.component';
import { NDAComponent } from './nda/nda.component';
import { AssignempComponent } from './assignemp/assignemp.component';
import { ExchangeComponent } from './exchange/exchange.component';
import { ClientFileUploadComponent } from './client-file-upload/client-file-upload.component';
import { BankgauranteeComponent } from './bankgaurantee/bankgaurantee.component';
import { OutputComponent } from './output/output.component';
import { BondComponent } from './bond/bond.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {AntidumpingComponent } from './antidumping/antidumping.component';
import {CustomnotifyComponent } from './customnotify/customnotify.component';
import {EximComponent } from './exim/exim.component';
import { ImportpartmasterComponent } from './importpartmaster/importpartmaster.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PartsComponent } from './parts/parts.component';
import { EmployeeComponent } from './employee/employee.component';
import { LicensedetailsComponent } from './licensedetails/licensedetails.component';
import { DashboadComponent } from './dashboad/dashboad.component';
import { UserrightsComponent } from './userrights/userrights.component';
import { LicenseMEISComponent } from './license-meis/license-meis.component';
import { LicenseAASComponent } from './license-aas/license-aas.component';
import { AuditReportComponent } from './audit-report/audit-report.component';
import { UnitsMasterComponent } from './units-master/units-master.component';

@NgModule({
  declarations: [
    AppComponent,
    ReaddataComponent,
    LoginComponent,
    MasterrComponent,
    CountrymasterComponent,
    CurrencymasterComponent,
    AdminmenuComponent,
    OnboardingComponent,
    ChamasterComponent,
    PortmasterComponent,
    ContractsComponent,
NDAComponent,
AssignempComponent,
ExchangeComponent,
ClientFileUploadComponent,
BankgauranteeComponent,
OutputComponent,
BondComponent,
AntidumpingComponent,
CustomnotifyComponent,
EximComponent,
ImportpartmasterComponent,
PartsComponent,
EmployeeComponent,
LicensedetailsComponent,
DashboadComponent,
UserrightsComponent,
LicenseMEISComponent,
LicenseAASComponent,
AuditReportComponent,
UnitsMasterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,HttpClientModule,FormsModule,ReactiveFormsModule,NgxSpinnerModule,MatDialogModule ,MatTableModule,MatPaginatorModule,MatSortModule,BrowserAnimationsModule,NgMultiSelectDropDownModule.forRoot(),NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
